"use client";
import classNames from "classnames";

import { useContext } from "react";

import ReactHtmlParser from "react-html-parser";

import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";

import Multimedia from "@sharedComponents/multimedia";

import styles from "./main.module.scss";

const CategoryBanner = ({ topContent, banner, mobileBanner }) => {
  const { isMobileDevice } = useContext(CurrentDeviceContext);

  const categoryBanner = isMobileDevice ? mobileBanner : banner;

  return (
    <div className={classNames(styles.categoryBannerContainer)}>
      {topContent && <div className={styles.categoryBannerText}>{ReactHtmlParser(topContent)}</div>}
      {categoryBanner && (
        <Multimedia
          type="image"
          height={205}
          className={styles.categoryBannerImg}
          src={categoryBanner}
          alt="Category Banner"
          fetchPriority="high"
        />
      )}
    </div>
  );
};

export default CategoryBanner;
